





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import BaseFormEdit from '../../models/base.form.edit';
import Donor from '../../models/donorForm';
import AddressTab from './Address.vue';
import PhoneTab from './Phones.vue';
import MailTab from './Mails.vue';
import SocialNetworkTab from './SocialNetworks.vue';
import axios from 'axios';
import Constants from '@/constants';
import FileUploader from '@/components/FileUploader.vue';
import Typeahead from 'vue-typeahead-bootstrap';
import moment from 'moment';
var jsonp = require('jsonp');

@Component({
  components: {
    FileUploader,
    Typeahead,
    AddressTab,
    PhoneTab,
    MailTab,
    SocialNetworkTab,
  },
})
export default class Edit extends BaseFormEdit {
  public form: any = new Donor();
  public urlPrefix = 'pmdd';
  public files: any[] = [];
  public cities: any[] = [];
  public genders: any[] = [];
  public usersInR3Group: any[] = [];
  public bloodTypes: any[] = [];
  public biomaterialSamples: any[] = [];
  public regions: any[] = [];
  public rhs: any[] = [];
  public deletionReasons: any[] = [];
  public initialDeletionReasons: any[] = [];
  public learnedFroms: any[] = [];
  public entryMedicalOffices: any[] = [];
  public entryActions: any[] = [];
  public nationalities: any[] = [];
  public diseases: any[] = [];
  public dataProcessingAgreements: any[] = [];
  public socialNetworks: any[] = [];
  public inWorkStatus = 2;
  public inWorkConfirmedStatus = 6;
  public activeStatus = 8;
  public deletedStatus = 9;
  public waitingStatus = 3;
  public prepareUtilizationStatus = 4;
  public utilizationStatus = 7;

  get title() {
    if (this.form.is_new) {
      return this.$t('Добавление анкеты донора') + '';
    }
    let result = this.$t('Анкета донора') + ' ';
    if (this.form.idd) {
      result += 'IDD ' + this.form.idd;
    }
    if (this.$auth.user().isLab) {
      return result;
    }
    if (this.form.last_name ||
      this.form.first_name ||
      this.form.patronymic_name
    ) {
      result += `, ${this.form.last_name} ${this.form.first_name} ${this.form.patronymic_name}`;
    }
    if (this.form.age) {
      result += `, ${this.form.age}`;
    }
    if (this.regions &&
        this.form.donor_addresses &&
        this.regions.length > 0 &&
        this.form.donor_addresses.length > 0) {
      const address = this.form.donor_addresses[0];
      const id = address.region_id;
      const region = this.regions.find((t) => t.key == id);
      result += `, ${region.value}`;
      if (address.city) {
        result += `, ${address.city}`;
      }
    }
    return result;
  }

  get bodyMassIndex() {
    return this.form.weight && this.form.height ? (this.form.weight / (this.form.height * this.form.height * 0.0001)).toFixed(2) : null;
  }
  
  get signedAt() {
    return this.form.certificate && this.form.certificate.signed_at ?
           moment(this.form.certificate.signed_at).format('DD.MM.YYYY') : 'Не указана';
  }

  get receiptInAnoAt() {
    return this.form.certificate && this.form.certificate.receipt_in_ano_at ?
           moment(this.form.certificate.receipt_in_ano_at).format('DD.MM.YYYY') : 'Не указана';
  }

  get receiptInLaboratoryAt() {
    return this.form.certificate && this.form.certificate.receipt_in_laboratory_at ?
           moment(this.form.certificate.receipt_in_laboratory_at).format('DD.MM.YYYY') : 'Не указана';
  }

  get yesNoOptions() {
    return [
      { text: this.$t('Не выбрано'), value: '' },
      { text: this.$t('Да'), value: true },
      { text: this.$t('Нет'), value: false },
    ];
  }

  get entryOptions() {
    return [
      { text: this.$t('Не выбрано'), value: '' },
      { text: this.$t('Акция'), value: 1 },
      { text: this.$t('Мед. учреждения'), value: 2 },
      { text: this.$t('Казань Экспресс'), value: 3 },
      { text: this.$t('Почта России'), value: 5 },
    ];
  }

  get yesNoOptionsWithoutEmpty() {
    return this.yesNoOptions.filter(t => t.value !== '');
  }

  public isLabIdUnique = {
    validate(value: any, args: any) {
      return axios.get('/pmdd/donorsForm/validateLabId?lab=' + value + '&id=' + args[0])
                  .then((response) => {
                    return response.data;
                  });
    },
  };

  public entryTypeChanged() {
    this.form.entry_action_id = null;
    this.form.income_city = null;
    this.form.entry_medical_office_id = null;
  }

  public findCity() {
    const self = this;
    jsonp(`https://kladr-api.ru/api.php?contentType=city&limit=10&query=${this.form.income_city}`, null,
      function (__err, data) {
        self.cities = data.result;
      });
  }

  public saveDuplicate(param) {
    const msgHtml = document.createElement('div');
    msgHtml.innerHTML = param.message;
    const self = this;
    // @ts-ignore
    this.$swal({
      icon: 'warning',
      title: this.$t('Предупреждение'),
      content: msgHtml,
      buttons: [this.$t('Отмена'), this.$t('Сохранить')],
    }).then(async (doChange: any) => {
      if (doChange) {
        self.form.is_duplicate = true;
        self.save();
      }
    });
  }

  public yesNoOptionsClass(val: any) {
    if (val === '') {
      return 'outline-secondary';
    }
    return !val ? 'outline-warning' : 'outline-primary';
  }

  public entryOptionsClass(val: any) {
    switch (val) {
      case 1: return 'outline-warning';
      case 2: return 'outline-primary';
      case 3: return 'outline-danger';
      case 4: return 'outline-warning';
      case 5: return 'outline-danger';
    }
    return 'outline-secondary';
  }

  public submitOnEnter(e: any) {
    const modal = document.querySelector('.modal.show');
    if (e.key === 'Enter' && e.target.type !== 'textarea' && modal == null && !e.target.hasAttribute('aria-selected')) {
      this.save();
      e.preventDefault();
    }
  }

  public created() {
    this.getDictionaries();
    this.parentValidator.extend('isLabIdUnique', this.isLabIdUnique);
  }

  public getDictionaries() {
    axios.get('/pmdd/DictionaryGroup').then((response) => {
      this.genders = response.data.genders;
      this.usersInR3Group = response.data.users_in_r3_group;
      this.biomaterialSamples = response.data.biomaterial_samples;
      this.learnedFroms = response.data.learned_froms;
      this.entryActions = response.data.entry_actions;
      this.nationalities = response.data.nationalities;
      this.entryMedicalOffices = response.data.entry_medical_offices;
      this.diseases = response.data.diseases;
      this.dataProcessingAgreements = response.data.data_processing_agreements;
      this.socialNetworks = response.data.social_networks;
      this.regions = response.data.regions;
      this.bloodTypes = response.data.blood_types;
      this.rhs = response.data.rhs;
      this.deletionReasons = response.data.deletion_reasons;
      this.deletionReasons.unshift({ key: '', value: '...' });
      this.initialDeletionReasons = response.data.initial_deletion_reasons;
      this.initialDeletionReasons.unshift({ key: '', value: '...' });
    });
  }

  public async onStatusChanged(status: any, type: string) {
    if (this.form.status === status) {
      return;
    }
    if ((status === this.inWorkStatus || status === this.inWorkConfirmedStatus)) {
        if(this.form.date_of_birth && this.$auth.user().roleNames.includes('Администратор РР')) {
          const age = this.calculateAge(new Date (this.form.date_of_birth));
          if (age != null && (age > 45 || age < 18)) {
            const msgHtml = document.createElement('div');
            msgHtml.innerHTML = '<span style="color:black; font-size: 18px">' +
                                'Возраст донора не входит в диапазон от <strong>18 до 45 лет</strong>!' +
                                '<br/>' +
                                '<strong>Продолжить</strong>?' +
                                '</span>';
            this.confirm(msgHtml, () => {
              this.saveStatus(status);
            });
            return;
          }
      }
      if(this.form.comment) {
        const msgHtml = document.createElement('div');
        msgHtml.innerHTML = '<span style="color:black; font-size: 18px">' +
            'Обратите внимание! В графе комментарии есть записи.' +
            '<br/>' +
            '<strong>Продолжить</strong>?' +
            '</span>';
        this.confirm(msgHtml, () => {
          this.saveStatus(status);
        });
        return;
      }
    }
    if (type === 'prev' || type === 'confirm') {
      const newStatusName = this.form[type + '_statuses'].filter((s) => s.key === status)[0].value;
      const msgText = Constants.RevertStatusMessageTemplate.replace('#status#', newStatusName);
      const msgHtml = document.createElement('div');
      msgHtml.innerHTML = msgText;
      const self = this;
      this.confirm(msgHtml, () => {
        self.saveStatus(status);
      });
    } else {
      this.saveStatus(status);
    }
  }

  public checkOptionalImportantFields(action) {
    if ((!this.form.data_processing_agreement_ids ||
        this.form.data_processing_agreement_ids.length === 0) &&
        this.form.ignore_not_fill_data_processing_agreement !== true) {
        const self = this;
        const msgHtml = document.createElement('div');
        msgHtml.innerHTML = '<div style="color:black; font-size: 18px">Не заполнено согласие на обработку данных. Продолжить?</div>';
        // @ts-ignore
        this.$swal({
          icon: 'warning',
          title: this.$t('Предупреждение'),
          content: msgHtml,
          buttons: {
              cancel: "Отмена",
              hide: {
                  className: "btn-secondary",
                  text: this.$t('Да (Больше не показывать)'),
                  value: "hide"
              },
              ok: {
                  className: "btn-primary",
                  text: this.$t('Да'),
                  value: "ok"
              },
          }
        }).then(async (doChange: any) => {
          if (doChange === 'hide') {
            self.form.ignore_not_fill_data_processing_agreement = true;
          }
          if (doChange === 'ok' || doChange === 'hide') {
            action();
          }
        });
    } else {
      action();
    }
  }

  public save() {
    this.checkOptionalImportantFields(() => this.submit('/donorsForm'));
  }

  public async saveStatus(status) {
    const oldStatus = this.form.status;
    this.form.status = status;
    const self = this;
    this.checkOptionalImportantFields(async () =>  {
        await this.submit('/donorsForm', false, '', null, this.showStatusChangeError);
        if (self.isStatusChangeError) {
          self.form.status = oldStatus;
        }
    });
  }

  protected mounted() {
    window.addEventListener('keydown', this.submitOnEnter);
    const radioGroups = document.getElementsByClassName('btn-group-toggle');
    for (const radioGroup of radioGroups) {
      const tabindex = radioGroup.getAttribute('tabindex');
      if (tabindex) {
        const inputs = radioGroup.querySelectorAll('input');
        for (const input of inputs) {
          input.setAttribute('tabindex', tabindex);
        }
        radioGroup.removeAttribute('tabindex');
      }
    }
    const labId = document.getElementById('laboratory-id');
    if (labId) {
      labId.focus();
    }
  }

  protected onFetchDataFinish() {
    this.$nextTick(() => {
      document.querySelectorAll('.multiselect__tag-icon').forEach(b => b.removeAttribute('tabindex'));
      document.querySelectorAll('.typeahead input').forEach(b =>  {
        b.setAttribute('tabindex', '18');
        b.setAttribute('autocomplete', 'new-text');
      });
    });
  }

  protected beforeDestroy() {
    window.removeEventListener('keydown', this.submitOnEnter);
  }
}
